<template>
  <div id="app">
    <AppCookiePolicy />
    <router-view></router-view>
  </div>
</template>

<script>
import AppCookiePolicy from "@/components/AppCookiePolicy";

export default {
  name: "app",
  components: {
    AppCookiePolicy
  },
  data() {
    return {};
  }
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>